"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAIRINGS = exports.FONTS = exports.PALETTE_KEYS = exports.FULL_PALETTE_KEYS = exports.BASIC_PALETTE_KEYS = exports.FULL_COLOR_TYPES = exports.BASIC_COLOR_TYPES = exports.UX_COLOR_SYSTEMS = exports.BRIGHTNESS_PALETTES = exports.THEME_NAMES = exports.TEXT_COLOR_KEYS = exports.BACKGROUND_COLOR_KEYS = exports.BRAND_COLOR_KEYS = void 0;
__exportStar(require("./baseThemes"), exports);
__exportStar(require("./fonts"), exports);
exports.BRAND_COLOR_KEYS = ['primary'];
exports.BACKGROUND_COLOR_KEYS = [
    'primary',
    'secondary',
    'divider',
    'opacity',
];
exports.TEXT_COLOR_KEYS = ['primary', 'secondary', 'placeholder'];
exports.THEME_NAMES = ['opal'];
exports.BRIGHTNESS_PALETTES = ['light', 'dark'];
exports.UX_COLOR_SYSTEMS = [
    'success',
    'warning',
    'danger',
    'info',
];
exports.BASIC_COLOR_TYPES = ['red', 'orange', 'green', 'blue'];
exports.FULL_COLOR_TYPES = ['neutral'];
exports.BASIC_PALETTE_KEYS = [100, 200, 300, 400];
exports.FULL_PALETTE_KEYS = __spreadArray(__spreadArray([], exports.BASIC_PALETTE_KEYS, true), [
    500,
    600,
    700,
    800,
], false);
exports.PALETTE_KEYS = exports.BASIC_COLOR_TYPES.reduce(function (topAcc, color) { return __spreadArray(__spreadArray([], topAcc, true), exports.BASIC_PALETTE_KEYS.reduce(function (acc, key) { return __spreadArray(__spreadArray([], acc, true), ["".concat(color, ".").concat(key)], false); }, []), true); }, []);
exports.FONTS = [
    'Abril Fatface',
    'Cabin',
    'Poppins',
    'DM Sans',
    'Manrope',
    'Playfair Display',
    'IBM Plex Sans',
    'Oswald',
    'Cardo',
    'Syne',
    'Nunito',
    'Noto Serif Display',
    'Raleway',
    'Inter',
];
exports.PAIRINGS = [
    'chic',
    'geometric',
    'modern',
    'elegant',
    'urban',
    'super',
    'luxury',
];
//# sourceMappingURL=index.js.map